import { render } from "./BarChart.vue?vue&type=template&id=84326d14&ts=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__